import { z } from 'zod';

import { parseConfig } from './parse-config';

export const urlConfigSchema = z.object({
    frontend: z.string(),
    backend: z.string(),
    api: z.string(),
    ai: z.string(),
    landingPage: z.string(),
    files: z.string().default('https://files.dcide.app'),
});

const gitCommitRef = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF ?? process.env.VERCEL_GIT_COMMIT_REF;
const vercelUrl = process.env.NEXT_PUBLIC_VERCEL_URL ?? process.env.VERCEL_URL;
const previewOverride = gitCommitRef?.startsWith('test/') && vercelUrl ? `https://${vercelUrl}` : undefined;

export const urlConfig = parseConfig('URL configuration', urlConfigSchema, {
    ai: process.env.NEXT_PUBLIC_AI_URL,
    landingPage: process.env.NEXT_PUBLIC_LANDING_PAGE,
    api: previewOverride ? `${previewOverride}/api` : process.env.NEXT_PUBLIC_BACKEND_URL,
    frontend: previewOverride ?? process.env.NEXT_PUBLIC_FRONTEND_URL,
    backend: previewOverride ?? process.env.NEXT_PUBLIC_SERVER_URL,
    files: process.env.NEXT_PUBLIC_FILES_URL,
});
